import React, { useState } from 'react';
import { Link, useHistory } from 'react-router-dom';
import InputMask from 'react-input-mask';
import * as yup from 'yup';
import { cpf as cpfValidator, cnpj as cnpjValidator } from 'cpf-cnpj-validator';
import api from '../../services/api';
import {
  GlobalStyle,
  Container,
  Header,
  Logo,
  Nav,
  NavLinks,
  MobileMenuContainer,
  HamburgerButton,
  MobileMenu,
  MobileMenuLink,
  MobileLoginButton,
  LoginButton,
  Footer,
  FooterContent,
  FooterSection,
  FooterLogo,
  FooterBottom,
  SocialIcons,
  SocialIcon,
  HeroSection,
  HeroContent,
  HeroBadge,
  HeroTitle,
  HeroSubtitle,
  BenefitsGrid,
  BenefitItem,
  ResultBox,
  ScrollCTA,
  TestimonialsSection,
  TestimonialsTitle,
  TestimonialsSubtitle,
  CarouselContainer,
  CarouselViewport,
  CarouselSlide,
  CarouselControls,
  CarouselButton,
  CarouselDots,
  CarouselDot,
  CarouselCounter,
  FormSection_Wrapper,
  FormContentWrapper,
  FormCard,
  FormTitle,
  FormSection,
  FormSectionTitle,
  FormRow,
  FormGroup,
  FormLabel,
  FormInput,
  FormSelect,
  SubmitButton,
  CheckboxContainer,
  StatusMessage,
  FieldError,
  PixBox,
  WhatsAppButton
} from './styled';
import logo from '../../assets/logo_navbar.png';
import depoimento1 from '../../assets/img/depoimentos_planos_uerj/depoimento 1.jpeg';
import depoimento2 from '../../assets/img/depoimentos_planos_uerj/depoimento 2.jpeg';
import depoimento3 from '../../assets/img/depoimentos_planos_uerj/depoimento 3.jpeg';
import depoimento4 from '../../assets/img/depoimentos_planos_uerj/depoimento 4.jpeg';
import depoimento5 from '../../assets/img/depoimentos_planos_uerj/depoimento 5.jpeg';
import depoimento6 from '../../assets/img/depoimentos_planos_uerj/depoimento 6.jpeg';

const depoimentos = [depoimento1, depoimento2, depoimento3, depoimento4, depoimento5, depoimento6];

const stripMask = (value) => value ? value.replace(/\D/g, '') : '';

const validationSchema = yup.object().shape({
  nome: yup.string().required('Nome é obrigatório').min(3, 'Nome deve ter no mínimo 3 caracteres'),
  cpf: yup.string().required('CPF é obrigatório').test('cpf-valid', 'CPF inválido', value => {
    if (!value) return false;
    return cpfValidator.isValid(stripMask(value));
  }),
  email: yup.string().required('Email é obrigatório').email('Email inválido'),
  senha: yup.string().required('Senha é obrigatória').min(6, 'Mínimo 6 caracteres')
    .matches(/[A-Z]/, 'Deve conter letra maiúscula')
    .matches(/[a-z]/, 'Deve conter letra minúscula')
    .matches(/[0-9]/, 'Deve conter um número')
    .matches(/[@$!%*?&#]/, 'Deve conter caractere especial (@$!%*?&#)'),
  telefone: yup.string().required('Telefone é obrigatório').test('tel-valid', 'Telefone inválido', value => {
    if (!value) return false;
    return stripMask(value).length >= 10;
  }),
  portador_nome: yup.string().required('Nome do portador é obrigatório').min(3, 'Mínimo 3 caracteres'),
  portador_email: yup.string().required('Email é obrigatório').email('Email inválido'),
  portador_cpf_cnpj: yup.string().required('CPF/CNPJ é obrigatório').test('cpf-cnpj-valid', 'CPF/CNPJ inválido', value => {
    if (!value) return false;
    const digits = stripMask(value);
    return cpfValidator.isValid(digits) || cnpjValidator.isValid(digits);
  }),
  portador_telefone: yup.string().required('Telefone é obrigatório').test('tel-valid', 'Telefone inválido', value => {
    if (!value) return false;
    return stripMask(value).length >= 10;
  }),
  portador_cep: yup.string().required('CEP é obrigatório').test('cep-valid', 'CEP inválido (8 dígitos)', value => {
    if (!value) return false;
    return stripMask(value).length === 8;
  }),
  portador_numero: yup.string().required('Número é obrigatório'),
  cartao_numero: yup.string().required('Número do cartão é obrigatório').test('card-valid', 'Número inválido (13 a 16 dígitos)', value => {
    if (!value) return false;
    return stripMask(value).length >= 13 && stripMask(value).length <= 16;
  }),
  cartao_mes: yup.string().required('Obrigatório').test('mes-valid', 'Mês inválido', value => {
    const num = parseInt(value);
    return num >= 1 && num <= 12;
  }),
  cartao_ano: yup.string().required('Obrigatório').test('ano-valid', 'Ano inválido', value => {
    const num = parseInt(value);
    return num >= new Date().getFullYear() && num <= new Date().getFullYear() + 15;
  }),
  cartao_ccv: yup.string().required('Obrigatório').matches(/^\d{3,4}$/, 'CCV: 3 ou 4 dígitos'),
  cartao_parcelas: yup.string().required('Selecione'),
});

const step1Schema = yup.object().shape({
  nome: yup.string().required('Nome é obrigatório').min(3, 'Nome deve ter no mínimo 3 caracteres'),
  cpf: yup.string().required('CPF é obrigatório').test('cpf-valid', 'CPF inválido', value => {
    if (!value) return false;
    return cpfValidator.isValid(stripMask(value));
  }),
  email: yup.string().required('Email é obrigatório').email('Email inválido'),
  senha: yup.string().required('Senha é obrigatória').min(6, 'Mínimo 6 caracteres')
    .matches(/[A-Z]/, 'Deve conter letra maiúscula')
    .matches(/[a-z]/, 'Deve conter letra minúscula')
    .matches(/[0-9]/, 'Deve conter um número')
    .matches(/[@$!%*?&#]/, 'Deve conter caractere especial (@$!%*?&#)'),
  telefone: yup.string().required('Telefone é obrigatório').test('tel-valid', 'Telefone inválido', value => {
    if (!value) return false;
    return stripMask(value).length >= 10;
  }),
});

function ZoomPage() {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [sameAsUser, setSameAsUser] = useState(false);
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState({ type: '', text: '' });
  const [errors, setErrors] = useState({});
  const [step, setStep] = useState(1);
  const [planoZoom, setPlanoZoom] = useState({ preco: null, quant_parcelas: 12 });
  const [currentSlide, setCurrentSlide] = useState(0);
  const autoplayRef = React.useRef(null);
  const menuRef = React.useRef();
  const hamburgerRef = React.useRef();
  const history = useHistory();

  const [formData, setFormData] = useState({
    nome: '',
    cpf: '',
    email: '',
    senha: '',
    telefone: '',
    portador_nome: '',
    portador_email: '',
    portador_cpf_cnpj: '',
    portador_telefone: '',
    portador_cep: '',
    portador_numero: '',
    cartao_numero: '',
    cartao_mes: '',
    cartao_ano: '',
    cartao_ccv: '',
    cartao_parcelas: '1'
  });

  React.useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  React.useEffect(() => {
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  React.useEffect(() => {
    autoplayRef.current = setInterval(() => {
      setCurrentSlide(prev => (prev + 1) % depoimentos.length);
    }, 4000);
    return () => clearInterval(autoplayRef.current);
  }, []);

  const resetAutoplay = () => {
    clearInterval(autoplayRef.current);
    autoplayRef.current = setInterval(() => {
      setCurrentSlide(prev => (prev + 1) % depoimentos.length);
    }, 4000);
  };

  const goToSlide = (idx) => {
    setCurrentSlide(idx);
    resetAutoplay();
  };

  const prevSlide = () => {
    setCurrentSlide(prev => prev === 0 ? depoimentos.length - 1 : prev - 1);
    resetAutoplay();
  };

  const nextSlide = () => {
    setCurrentSlide(prev => (prev + 1) % depoimentos.length);
    resetAutoplay();
  };

  React.useEffect(() => {
    const fetchPrecos = async () => {
      try {
        const response = await api.get('/precos-planos');
        if (response.data?.zoom) {
          setPlanoZoom(response.data.zoom);
        }
      } catch (error) {
        console.error('Erro ao buscar preços:', error);
      }
    };
    fetchPrecos();
  }, []);

  const handleLoginClick = () => {
    history.push('/login');
  };

  const toggleMobileMenu = (e) => {
    if (e) e.stopPropagation();
    setMobileMenuOpen(!mobileMenuOpen);
  };

  const handleClickOutside = (event) => {
    if (
      mobileMenuOpen &&
      menuRef.current &&
      !menuRef.current.contains(event.target) &&
      hamburgerRef.current &&
      !hamburgerRef.current.contains(event.target)
    ) {
      setMobileMenuOpen(false);
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
    if (errors[name]) {
      setErrors(prev => ({ ...prev, [name]: '' }));
    }
  };

  const handleSameAsUser = (e) => {
    const checked = e.target.checked;
    setSameAsUser(checked);
    if (checked) {
      setFormData(prev => ({
        ...prev,
        portador_nome: prev.nome,
        portador_email: prev.email,
        portador_cpf_cnpj: prev.cpf,
        portador_telefone: prev.telefone
      }));
    }
  };

  const handleNext = async (e) => {
    e.preventDefault();
    setMessage({ type: '', text: '' });
    setErrors({});

    try {
      await step1Schema.validate(formData, { abortEarly: false });
    } catch (validationError) {
      const fieldErrors = {};
      validationError.inner.forEach(err => {
        if (!fieldErrors[err.path]) fieldErrors[err.path] = err.message;
      });
      setErrors(fieldErrors);
      return;
    }

    setStep(2);
    window.scrollTo({ top: document.getElementById('matricula')?.offsetTop - 80 || 0, behavior: 'smooth' });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setMessage({ type: '', text: '' });
    setErrors({});

    try {
      await validationSchema.validate(formData, { abortEarly: false });
    } catch (validationError) {
      const fieldErrors = {};
      validationError.inner.forEach(err => {
        if (!fieldErrors[err.path]) {
          fieldErrors[err.path] = err.message;
        }
      });
      setErrors(fieldErrors);
      return;
    }

    setLoading(true);

    const payload = {
      usuario: {
        nome: formData.nome,
        cpf: stripMask(formData.cpf),
        email: formData.email,
        senha: formData.senha,
        telefone: formData.telefone
      },
      cartao_credito: {
        portador: {
          nome: formData.portador_nome,
          email: formData.portador_email,
          cpf_cnpj: stripMask(formData.portador_cpf_cnpj),
          telefone: formData.portador_telefone,
          endereco: {
            cep: stripMask(formData.portador_cep),
            numero: formData.portador_numero
          }
        },
        dados_cartao: {
          numero: stripMask(formData.cartao_numero),
          mes_expiracao: formData.cartao_mes,
          ano_expiracao: formData.cartao_ano,
          ccv: formData.cartao_ccv,
          numero_parcelas: parseInt(formData.cartao_parcelas)
        }
      }
    };

    try {
      const response = await api.post('/pagamento/credito', payload);
      const { dados_user, pagamento } = response.data;
      const statusLabel = pagamento?.status === 'APROVADO'
        ? 'aprovado'
        : pagamento?.status === 'RECUSADO'
        ? 'recusado'
        : pagamento?.status === 'PENDENTE'
        ? 'pendente'
        : 'em processamento';
      setMessage({
        type: 'success',
        text: `Matrícula realizada com sucesso! Pagamento ${statusLabel}. Redirecionando para o login...`
      });
      setTimeout(() => {
        history.push('/login');
      }, 3000);
    } catch (error) {
      const status = error.response?.status;
      const data = error.response?.data;
      let msg = 'Erro ao processar pagamento. Tente novamente.';

      if (status === 400) {
        msg = data?.message || 'Dados inválidos ou pagamento não autorizado. Verifique os dados e tente novamente.';
      } else if (status === 500) {
        msg = data?.message || 'Erro interno no servidor.';
        if (data?.reference) {
          msg += ` Referência: ${data.reference}. Entre em contato com o suporte.`;
        }
      } else if (status === 502) {
        msg = data?.message || 'Erro ao comunicar com o processador de pagamento. Tente novamente em alguns minutos.';
      }

      setMessage({ type: 'error', text: msg });
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
    <GlobalStyle />
    <Container>
      <Header>
        <Nav>
          <Logo>
            <Link to="/">
              <img src={logo} alt="Logo" />
            </Link>
          </Logo>
          <NavLinks>
            <Link to="/">Página Inicial</Link>
          </NavLinks>
          <LoginButton onClick={handleLoginClick}>Fazer Login</LoginButton>
        </Nav>
        <MobileMenuContainer>
          <HamburgerButton
            ref={hamburgerRef}
            open={mobileMenuOpen}
            onClick={toggleMobileMenu}
          >
            <span></span>
            <span></span>
            <span></span>
          </HamburgerButton>
          {mobileMenuOpen && (
            <MobileMenu isOpen={mobileMenuOpen} ref={menuRef}>
              <MobileMenuLink as={Link} to="/">Página Inicial</MobileMenuLink>
              <MobileLoginButton onClick={handleLoginClick}>Login na Plataforma</MobileLoginButton>
            </MobileMenu>
          )}
        </MobileMenuContainer>
      </Header>

      <HeroSection>
        <HeroContent>
          <HeroBadge>VAGAS LIMITADAS!</HeroBadge>
          <HeroTitle>
            Curso On-line pelo Zoom
            <span>Redação Nota Máxima na UERJ</span>
          </HeroTitle>

          <div style={{
            margin: '1.5rem auto 2rem',
            width: 'min(480px, 90vw, calc(75vh * 9 / 16))',
            aspectRatio: '9/16',
            borderRadius: '16px',
            overflow: 'hidden',
            boxShadow: '0 12px 40px rgba(0,0,0,0.3)',
            border: '3px solid rgba(255,255,255,0.2)'
          }}>
            <iframe
              src="https://www.youtube.com/embed/lC6geK1rimM?autoplay=1&loop=1&playlist=lC6geK1rimM&controls=0&showinfo=0&rel=0"
              title="Vídeo do curso"
              allow="autoplay; encrypted-media"
              allowFullScreen
              style={{ width: '100%', height: '100%', border: 'none' }}
            />
          </div>

          <HeroSubtitle>
            Aulas ao vivo com a professora Danielle Velasco. Domine a redação da UERJ e conquiste sua nota máxima com acompanhamento personalizado.<br/><strong style={{ color: '#ffc107' }}>Início das aulas: 08 de maio de 2026</strong>
          </HeroSubtitle>

          {planoZoom.preco !== null && (
            <div style={{
              background: 'rgba(255,255,255,0.12)',
              backdropFilter: 'blur(12px)',
              borderRadius: '24px',
              padding: '1.5rem 2rem',
              display: 'inline-block',
              marginBottom: '2.5rem',
              border: '1px solid rgba(255,255,255,0.2)',
              boxShadow: '0 8px 32px rgba(0,0,0,0.15)',
              maxWidth: '90vw'
            }}>
              <div style={{ fontSize: '1rem', opacity: 0.7, letterSpacing: '2px', textTransform: 'uppercase', marginBottom: '0.2rem' }}>
                Em até
              </div>
              <div style={{ fontSize: 'clamp(2.2rem, 8vw, 3.2rem)', fontWeight: 900, color: '#ffc107', lineHeight: 1.1 }}>
                {planoZoom.quant_parcelas}x
              </div>
              <div style={{ fontSize: '1rem', fontWeight: 600, opacity: 0.7, margin: '0.3rem 0', textTransform: 'uppercase' }}>
                de
              </div>
              <div style={{ fontSize: 'clamp(2rem, 7vw, 3.2rem)', fontWeight: 900, lineHeight: 1.1 }}>
                R${(planoZoom.preco / planoZoom.quant_parcelas).toFixed(2).replace('.', ',')}
              </div>
              <div style={{ width: '60px', height: '2px', background: 'rgba(255,193,7,0.5)', margin: '0.8rem auto' }} />
              <div style={{ fontSize: '0.9rem', opacity: 0.6, textTransform: 'uppercase' }}>
                Total: R${planoZoom.preco.toFixed(2).replace('.', ',')}
              </div>
              <a
                href="https://wa.me/5521969570209?text=Ol%C3%A1!%20Tenho%20interesse%20no%20curso%20de%20reda%C3%A7%C3%A3o%20UERJ%20e%20gostaria%20de%20pagar%20via%20PIX."
                target="_blank"
                rel="noopener noreferrer"
                style={{ display: 'block', marginTop: '1rem', background: 'rgba(76,175,80,0.25)', border: '1px solid rgba(76,175,80,0.4)', borderRadius: '10px', padding: '0.6rem 1rem', fontSize: '0.85rem', lineHeight: 1.4, color: 'white', textDecoration: 'none', cursor: 'pointer', transition: 'all 0.3s ease' }}
                onMouseEnter={e => { e.currentTarget.style.background = 'rgba(76,175,80,0.45)'; e.currentTarget.style.transform = 'scale(1.03)'; }}
                onMouseLeave={e => { e.currentTarget.style.background = 'rgba(76,175,80,0.25)'; e.currentTarget.style.transform = 'scale(1)'; }}
              >
                <strong style={{ color: '#81c784' }}>PIX com 10% OFF!</strong><br/>
                Valor à vista: <strong>R$ 1.800,00</strong> — via WhatsApp
              </a>
            </div>
          )}

          <BenefitsGrid>
            <BenefitItem>
              <svg width="20" height="20" viewBox="0 0 24 24" fill="#ffc107"><path d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z"/></svg>
              <p>Aulas ao vivo semanais de 1h e 30 minutos</p>
            </BenefitItem>
            <BenefitItem>
              <svg width="20" height="20" viewBox="0 0 24 24" fill="#ffc107"><path d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z"/></svg>
              <p>Material exclusivo utilizado em sala pensado pela professora Danielle Velasco.</p>
            </BenefitItem>
          
            <BenefitItem>
              <svg width="20" height="20" viewBox="0 0 24 24" fill="#ffc107"><path d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z"/></svg>
              <p>1 Mentoria mensal</p>
            </BenefitItem>
          
            <BenefitItem>
              <svg width="20" height="20" viewBox="0 0 24 24" fill="#ffc107"><path d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z"/></svg>
              <p>A correção é feita pela equipe de professores especializados na prova de redação do Enem e supervisionado pela professora Danielle.</p>
            </BenefitItem>
            <BenefitItem>
              <svg width="20" height="20" viewBox="0 0 24 24" fill="#ffc107"><path d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z"/></svg>
              <p>Acompanhamento individualizado pela coordenação com orientação específica.</p>
            </BenefitItem>
            <BenefitItem>
              <svg width="20" height="20" viewBox="0 0 24 24" fill="#ffc107"><path d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z"/></svg>
              <p>Acesso a nossa plataforma de correção própria e exclusiva, com todos os erros apontados e comentados.</p>
            </BenefitItem>
            <BenefitItem>
              <svg width="20" height="20" viewBox="0 0 24 24" fill="#ffc107"><path d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z"/></svg>
              <p>Clube de leitura.</p>
            </BenefitItem>

            <BenefitItem>
              <svg width="20" height="20" viewBox="0 0 24 24" fill="#ffc107"><path d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z"/></svg>
              <p>Aulas interdisciplinares</p>
            </BenefitItem>
        
          </BenefitsGrid>

          <ResultBox>
            <strong>Resultado esperado:</strong> o aluno aprende a escrever de forma autoral para conquistar a sua nota máxima na redação da UERJ.
          </ResultBox>

          <ScrollCTA onClick={() => document.getElementById('matricula')?.scrollIntoView({ behavior: 'smooth' })}>
            Quero me matricular
            <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor"><path d="M7.41 8.59L12 13.17l4.59-4.58L18 10l-6 6-6-6z"/></svg>
          </ScrollCTA>
        </HeroContent>
      </HeroSection>

      <TestimonialsSection>
        <TestimonialsTitle>O que nossos <span>alunos</span> dizem</TestimonialsTitle>
        <TestimonialsSubtitle>Depoimentos reais de quem já faz parte do nosso curso</TestimonialsSubtitle>
        <CarouselContainer>
          <CarouselViewport>
            <CarouselSlide
              isActive={false}
              onClick={() => goToSlide(currentSlide === 0 ? depoimentos.length - 1 : currentSlide - 1)}
            >
              <img src={depoimentos[currentSlide === 0 ? depoimentos.length - 1 : currentSlide - 1]} alt="Depoimento anterior" />
            </CarouselSlide>
            <CarouselSlide isActive={true}>
              <img src={depoimentos[currentSlide]} alt={`Depoimento ${currentSlide + 1}`} />
            </CarouselSlide>
            <CarouselSlide
              isActive={false}
              onClick={() => goToSlide((currentSlide + 1) % depoimentos.length)}
            >
              <img src={depoimentos[(currentSlide + 1) % depoimentos.length]} alt="Próximo depoimento" />
            </CarouselSlide>
          </CarouselViewport>
          <CarouselControls>
            <CarouselButton onClick={prevSlide}>
              <svg width="22" height="22" viewBox="0 0 24 24" fill="currentColor"><path d="M15.41 7.41L14 6l-6 6 6 6 1.41-1.41L10.83 12z"/></svg>
            </CarouselButton>
            <CarouselDots>
              {depoimentos.map((_, idx) => (
                <CarouselDot key={idx} active={idx === currentSlide} onClick={() => goToSlide(idx)} />
              ))}
            </CarouselDots>
            <CarouselCounter>{currentSlide + 1} / {depoimentos.length}</CarouselCounter>
            <CarouselButton onClick={nextSlide}>
              <svg width="22" height="22" viewBox="0 0 24 24" fill="currentColor"><path d="M10 6L8.59 7.41 13.17 12l-4.58 4.59L10 18l6-6z"/></svg>
            </CarouselButton>
          </CarouselControls>
        </CarouselContainer>
      </TestimonialsSection>

      <FormSection_Wrapper id="matricula">
        <FormContentWrapper>
          <FormCard onSubmit={step === 1 ? handleNext : handleSubmit}>
            <FormTitle>Faça sua matrícula</FormTitle>

            {/* Indicador de etapas */}
            <div style={{ display: 'flex', alignItems: 'center', margin: '0 0 24px', padding: '16px 0', borderBottom: '1px solid rgba(0,0,0,0.08)' }}>
              <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                <div style={{ width: '28px', height: '28px', borderRadius: '50%', background: '#1a3a5c', color: '#fff', display: 'flex', alignItems: 'center', justifyContent: 'center', fontWeight: '700', fontSize: '13px', flexShrink: 0 }}>
                  {step > 1 ? '✓' : '1'}
                </div>
                <span style={{ fontSize: '13px', fontWeight: step === 1 ? '700' : '400', color: step === 1 ? '#1a3a5c' : '#888' }}>Dados pessoais</span>
              </div>
              <div style={{ flex: 1, height: '2px', background: step >= 2 ? '#1a3a5c' : '#ddd', margin: '0 12px', minWidth: '20px' }} />
              <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                <div style={{ width: '28px', height: '28px', borderRadius: '50%', background: step >= 2 ? '#1a3a5c' : '#ddd', color: step >= 2 ? '#fff' : '#aaa', display: 'flex', alignItems: 'center', justifyContent: 'center', fontWeight: '700', fontSize: '13px', flexShrink: 0 }}>2</div>
                <span style={{ fontSize: '13px', fontWeight: step === 2 ? '700' : '400', color: step === 2 ? '#1a3a5c' : '#888' }}>Pagamento</span>
              </div>
            </div>

            {/* ── Etapa 1: Dados do Aluno ── */}
            {step === 1 && (
              <FormSection>
                <FormSectionTitle>Dados do Aluno</FormSectionTitle>
                <FormRow>
                  <FormGroup>
                    <FormLabel>Nome completo</FormLabel>
                    <FormInput type="text" name="nome" value={formData.nome} onChange={handleChange} placeholder="Seu nome completo" />
                    {errors.nome && <FieldError>{errors.nome}</FieldError>}
                  </FormGroup>
                  <FormGroup>
                    <FormLabel>CPF</FormLabel>
                    <FormInput as={InputMask} mask="999.999.999-99" name="cpf" value={formData.cpf} onChange={handleChange} placeholder="000.000.000-00" />
                    {errors.cpf && <FieldError>{errors.cpf}</FieldError>}
                  </FormGroup>
                </FormRow>
                <FormRow>
                  <FormGroup>
                    <FormLabel>Email</FormLabel>
                    <FormInput type="email" name="email" value={formData.email} onChange={handleChange} placeholder="seu@email.com" />
                    {errors.email && <FieldError>{errors.email}</FieldError>}
                  </FormGroup>
                  <FormGroup>
                    <FormLabel>Senha</FormLabel>
                    <FormInput type="password" name="senha" value={formData.senha} onChange={handleChange} placeholder="Crie uma senha" />
                    {errors.senha && <FieldError>{errors.senha}</FieldError>}
                  </FormGroup>
                  <FormGroup>
                    <FormLabel>Telefone</FormLabel>
                    <FormInput as={InputMask} mask="(99) 99999-9999" name="telefone" value={formData.telefone} onChange={handleChange} placeholder="(00) 00000-0000" />
                    {errors.telefone && <FieldError>{errors.telefone}</FieldError>}
                  </FormGroup>
                </FormRow>
                <SubmitButton type="submit">Próximo →</SubmitButton>
              </FormSection>
            )}

            {/* ── Etapa 2: Portador + Cartão ── */}
            {step === 2 && (
              <>
                <FormSection>
                  <FormSectionTitle>Dados do Portador do Cartão</FormSectionTitle>
                  <CheckboxContainer>
                    <input type="checkbox" id="sameAsUser" checked={sameAsUser} onChange={handleSameAsUser} />
                    <label htmlFor="sameAsUser">Mesmos dados do aluno</label>
                  </CheckboxContainer>
                  <FormRow>
                    <FormGroup>
                      <FormLabel>Nome do portador</FormLabel>
                      <FormInput type="text" name="portador_nome" value={formData.portador_nome} onChange={handleChange} placeholder="Nome no cartão" disabled={sameAsUser} />
                      {errors.portador_nome && <FieldError>{errors.portador_nome}</FieldError>}
                    </FormGroup>
                    <FormGroup>
                      <FormLabel>Email</FormLabel>
                      <FormInput type="email" name="portador_email" value={formData.portador_email} onChange={handleChange} placeholder="email@exemplo.com" disabled={sameAsUser} />
                      {errors.portador_email && <FieldError>{errors.portador_email}</FieldError>}
                    </FormGroup>
                  </FormRow>
                  <FormRow>
                    <FormGroup>
                      <FormLabel>CPF/CNPJ</FormLabel>
                      <FormInput type="text" name="portador_cpf_cnpj" value={formData.portador_cpf_cnpj} onChange={handleChange} placeholder="CPF ou CNPJ (só números)" maxLength="14" disabled={sameAsUser} />
                      {errors.portador_cpf_cnpj && <FieldError>{errors.portador_cpf_cnpj}</FieldError>}
                    </FormGroup>
                    <FormGroup>
                      <FormLabel>Telefone</FormLabel>
                      <FormInput as={InputMask} mask="(99) 99999-9999" name="portador_telefone" value={formData.portador_telefone} onChange={handleChange} placeholder="(00) 00000-0000" disabled={sameAsUser} />
                      {errors.portador_telefone && <FieldError>{errors.portador_telefone}</FieldError>}
                    </FormGroup>
                    <FormGroup>
                      <FormLabel>CEP</FormLabel>
                      <FormInput as={InputMask} mask="99999-999" name="portador_cep" value={formData.portador_cep} onChange={handleChange} placeholder="00000-000" />
                      {errors.portador_cep && <FieldError>{errors.portador_cep}</FieldError>}
                    </FormGroup>
                    <FormGroup>
                      <FormLabel>Nº endereço</FormLabel>
                      <FormInput type="text" name="portador_numero" value={formData.portador_numero} onChange={handleChange} placeholder="123" />
                      {errors.portador_numero && <FieldError>{errors.portador_numero}</FieldError>}
                    </FormGroup>
                  </FormRow>
                </FormSection>

                <FormSection>
                  <FormSectionTitle>Dados do Cartão de Crédito</FormSectionTitle>
                  <FormRow>
                    <FormGroup>
                      <FormLabel>Número do cartão</FormLabel>
                      <FormInput as={InputMask} mask="9999 9999 9999 9999" name="cartao_numero" value={formData.cartao_numero} onChange={handleChange} placeholder="0000 0000 0000 0000" />
                      {errors.cartao_numero && <FieldError>{errors.cartao_numero}</FieldError>}
                    </FormGroup>
                    <FormGroup>
                      <FormLabel>Mês</FormLabel>
                      <FormInput type="text" name="cartao_mes" value={formData.cartao_mes} onChange={handleChange} placeholder="MM" maxLength="2" />
                      {errors.cartao_mes && <FieldError>{errors.cartao_mes}</FieldError>}
                    </FormGroup>
                    <FormGroup>
                      <FormLabel>Ano</FormLabel>
                      <FormInput type="text" name="cartao_ano" value={formData.cartao_ano} onChange={handleChange} placeholder="AAAA" maxLength="4" />
                      {errors.cartao_ano && <FieldError>{errors.cartao_ano}</FieldError>}
                    </FormGroup>
                    <FormGroup>
                      <FormLabel>CVC</FormLabel>
                      <FormInput type="text" name="cartao_ccv" value={formData.cartao_ccv} onChange={handleChange} placeholder="123" maxLength="4" />
                      {errors.cartao_ccv && <FieldError>{errors.cartao_ccv}</FieldError>}
                    </FormGroup>
                    <FormGroup>
                      <FormLabel>Parcelas</FormLabel>
                      <FormSelect name="cartao_parcelas" value={formData.cartao_parcelas} onChange={handleChange}>
                        {Array.from({ length: planoZoom.quant_parcelas }, (_, i) => i + 1).map(n => (
                          <option key={n} value={n}>
                            {n}x {planoZoom.preco ? `de R$ ${(planoZoom.preco / n).toFixed(2).replace('.', ',')}` : ''}
                          </option>
                        ))}
                      </FormSelect>
                    </FormGroup>
                  </FormRow>
                </FormSection>

                {message.text && (
                  <StatusMessage type={message.type}>{message.text}</StatusMessage>
                )}

                <div style={{ display: 'flex', gap: '12px' }}>
                  <button
                    type="button"
                    onClick={() => { setStep(1); setErrors({}); setMessage({ type: '', text: '' }); }}
                    disabled={loading}
                    style={{ padding: '14px 20px', background: '#f0f4f8', color: '#4a5568', border: 'none', borderRadius: '8px', fontSize: '14px', fontWeight: '600', cursor: 'pointer' }}
                  >
                    ← Voltar
                  </button>
                  <SubmitButton type="submit" disabled={loading} style={{ flex: 1 }}>
                    {loading ? 'Processando...' : 'Matricular-se Agora'}
                  </SubmitButton>
                </div>
              </>
            )}

            <PixBox>
              <h3>
                <svg width="20" height="20" viewBox="0 0 24 24" fill="#2e7d32"><path d="M9.5 4l3 3-3 3M14.5 4l-3 3 3 3M4 14.5l3-3-3-3M4 9.5l3 3-3 3M20 14.5l-3-3 3-3M20 9.5l-3 3 3 3M14.5 20l-3-3 3-3M9.5 20l3-3-3-3"/></svg>
                Prefere pagar via PIX?
              </h3>
              <span className="pix-discount">10% DE DESCONTO</span>
              <div className="pix-price">Valor total: R$ 1.800,00</div>
              <p>Pagamento via PIX é realizado exclusivamente pelo nosso WhatsApp.</p>
              <WhatsAppButton href="https://wa.me/5521969570209?text=Ol%C3%A1!%20Tenho%20interesse%20no%20curso%20de%20reda%C3%A7%C3%A3o%20UERJ%20e%20gostaria%20de%20pagar%20via%20PIX." target="_blank" rel="noopener noreferrer">
                <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor"><path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z"/></svg>
                Falar no WhatsApp
              </WhatsAppButton>
            </PixBox>
          </FormCard>
        </FormContentWrapper>
      </FormSection_Wrapper>

      <Footer id="contato">
          <FooterContent>
            <FooterSection>
              <FooterLogo>
                <img src={logo} alt="Logo" />
              </FooterLogo>
              
              <div className="NewsletterForm">
                {/* <input type="email" placeholder="Digite seu email" />
                <button>ENVIAR</button> */}
              </div>
            </FooterSection>
            <FooterSection>
              {/* <h4>Menu Acesso Rápido</h4>
              <a href="#">Página de exemplo</a>
              <a href="#">Página de exemplo</a>
              <a href="#">Página de exemplo</a> */}
            </FooterSection>
            <FooterSection>
              <h4>Fale com a gente!</h4>
              <p>
                <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor" style={{marginRight: '8px', verticalAlign: 'middle'}}>
                  <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893A11.821 11.821 0 0020.893 3.488"/>
                </svg>
                (21) 96957-0209
              </p>
              <p>
                <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor" style={{marginRight: '8px', verticalAlign: 'middle'}}>
                  <path d="M12,11.5A2.5,2.5 0 0,1 9.5,9A2.5,2.5 0 0,1 12,6.5A2.5,2.5 0 0,1 14.5,9A2.5,2.5 0 0,1 12,11.5M12,2A7,7 0 0,0 5,9C5,14.25 12,22 12,22S19,14.25 19,9A7,7 0 0,0 12,2Z"/>
                </svg>
                Rua Gavião Peixoto, 124, sala 509 - Edifício Manhattan
              </p>
              
              <p>
                <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor" style={{marginRight: '8px', verticalAlign: 'middle'}}>
                  <path d="M20,8L12,13L4,8V6L12,11L20,6M20,4H4C2.89,4 2,4.89 2,6V18A2,2 0 0,0 4,20H20A2,2 0 0,0 22,18V6C22,4.89 21.11,4 20,4Z"/>
                </svg>
                cursodaniellevelasco@gmail.com
              </p>
            </FooterSection>
          </FooterContent>
          <FooterBottom>
            <p>&copy; copyright {new Date().getFullYear()} Curso Danielle Velasco</p>
            <SocialIcons>
              <SocialIcon href="https://open.spotify.com/show/6OahTLB012BVlm26zUcMvn" target="_blank" rel="noopener noreferrer">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor">
                  <path d="M12 0C5.4 0 0 5.4 0 12s5.4 12 12 12 12-5.4 12-12S18.66 0 12 0zm5.521 17.34c-.24.359-.66.48-1.021.24-2.82-1.74-6.36-2.101-10.561-1.141-.418.122-.84-.179-.84-.6 0-.359.24-.66.54-.78 4.56-1.021 8.52-.6 11.64 1.32.42.18.479.659.242 1.021zm1.44-3.3c-.301.42-.841.6-1.262.3-3.239-1.98-8.159-2.58-11.939-1.38-.479.12-1.02-.12-1.14-.6-.12-.48.12-1.021.6-1.141C9.6 9.9 15 10.561 18.72 12.84c.361.181.54.78.241 1.2zm.12-3.36C15.24 8.4 8.82 8.16 5.16 9.301c-.6.179-1.2-.181-1.38-.721-.18-.601.18-1.2.72-1.381 4.26-1.26 11.28-1.02 15.721 1.621.539.3.719 1.02.42 1.56-.299.421-1.02.599-1.559.3z"/>
                </svg>
              </SocialIcon>
              <SocialIcon href="https://www.youtube.com/@cursodaniellevelasco" target="_blank" rel="noopener noreferrer">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor">
                  <path d="M23.498 6.186a3.016 3.016 0 0 0-2.122-2.136C19.505 3.545 12 3.545 12 3.545s-7.505 0-9.377.505A3.017 3.017 0 0 0 .502 6.186C0 8.07 0 12 0 12s0 3.93.502 5.814a3.016 3.016 0 0 0 2.122 2.136c1.871.505 9.376.505 9.376.505s7.505 0 9.377-.505a3.015 3.015 0 0 0 2.122-2.136C24 15.93 24 12 24 12s0-3.93-.502-5.814zM9.545 15.568V8.432L15.818 12l-6.273 3.568z"/>
                </svg>
              </SocialIcon>
              <SocialIcon href="https://www.tiktok.com/@cursodaniellevelasco" target="_blank" rel="noopener noreferrer">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor">
                  <path d="M12.525.02c1.31-.02 2.61-.01 3.91-.02.08 1.53.63 3.09 1.75 4.17 1.12 1.11 2.7 1.62 4.24 1.79v4.03c-1.44-.05-2.89-.35-4.2-.97-.57-.26-1.1-.59-1.62-.93-.01 2.92.01 5.84-.02 8.75-.08 1.4-.54 2.79-1.35 3.94-1.31 1.92-3.58 3.17-5.91 3.21-1.43.08-2.86-.31-4.08-1.03-2.02-1.19-3.44-3.37-3.65-5.71-.02-.5-.03-1-.01-1.49.18-1.9 1.12-3.72 2.58-4.96 1.66-1.44 3.98-2.13 6.15-1.72.02 1.48-.04 2.96-.04 4.44-.99-.32-2.15-.23-3.02.37-.63.41-1.11 1.04-1.36 1.75-.21.51-.15 1.07-.14 1.61.24 1.64 1.82 3.02 3.5 2.87 1.12-.01 2.19-.66 2.77-1.61.19-.33.4-.67.41-1.06.1-1.79.06-3.57.07-5.36.01-4.03-.01-8.05.02-12.07z"/>
                </svg>
              </SocialIcon>
              <SocialIcon href="https://www.instagram.com/cursodaniellevelasco" target="_blank" rel="noopener noreferrer">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor">
                  <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z"/>
                </svg>
              </SocialIcon>
              <SocialIcon href="https://wa.me/5521969570209" target="_blank" rel="noopener noreferrer">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor">
                  <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893A11.821 11.821 0 0020.465 3.488"/>
                </svg>
              </SocialIcon>
              <SocialIcon href="https://www.facebook.com/cursodaniellevelasco" target="_blank" rel="noopener noreferrer">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor">
                  <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z"/>
                </svg>
              </SocialIcon>
            </SocialIcons>
          </FooterBottom>
        </Footer>
      </Container>
    </>
  );
}

export default ZoomPage;